// import React, { useState, memo, useEffect } from "react";
// import API from "api.js";

// import SpeakingZoneIcon from "assets/images/images_new/microphone-icon.svg";
// import WritingZoneIcon from "assets/images/images_new/writing-icon.svg";
// import ReadingZoneIcon from "assets/images/images_new/reading-icon.svg";
// import ListeningZoneIcon from "assets/images/images_new/listening-icon.svg";
// import RightArrow from "assets/images/images_new/right-arrow.svg";
// import { Link } from "react-router-dom";

// const StatCategories = memo(function StatCategories({
// 	practiceData, showAverageScore
// }) {

// 	//  Speaking = 1
// 	//  Writing = 2
// 	//  Reading = 3
// 	//  Listening = 4
// 	return (
// 		<div id="tour-stats" className="col-md-7 pl-md-0"  >
// 			<div className="progress-section">
// 				<Section
// 					data={practiceData}
// 					title="Speaking"
// 					icon={SpeakingZoneIcon}
// 					class_name="speaking"
// 					category={1}
// 					showAverageScore={showAverageScore}
// 				/>

// 				<Section
// 					data={practiceData}
// 					title="Writing"
// 					icon={WritingZoneIcon}
// 					class_name="writing"
// 					category={2}
// 					showAverageScore={showAverageScore}
// 				/>

// 				<Section
// 					data={practiceData}
// 					title="Reading"
// 					icon={ReadingZoneIcon}
// 					class_name="reading"
// 					category={3}
// 					showAverageScore={showAverageScore}
// 				/>

// 				<Section
// 					data={practiceData}
// 					title="Listening"
// 					icon={ListeningZoneIcon}
// 					class_name="listening"
// 					category={4}
// 					showAverageScore={showAverageScore}
// 				/>
// 			</div>
// 		</div>
// 	);
// });


// const Section = ({
// 	data, title, icon, class_name, category, showAverageScore
// }) => {

// 	const [percentage, setPercentage] = useState(0);
// 	const [completed, setCompleted] = useState(0);
// 	const [total, setTotal] = useState(0);
// 	const [averageScore, setAverageScore] = useState(null);

// 	useEffect(() => {
// 		if (data) {
// 			switch(category) {
// 				case 1:
// 					setData(data.speaking);
// 					break;
// 				case 2:
// 					setData(data.writing);
// 					break;
// 				case 3:
// 					setData(data.reading);
// 					break;
// 				case 4:
// 					setData(data.listening);
// 					break;
// 				default:
// 					break;
// 			}
// 		}
// 	}, [data]);

// 	const setData = (d) => {
// 		setCompleted(d.done);
// 		setTotal(d.total);
// 		setPercentage(parseFloat((d.done / d.total) * 100).toFixed(2));
// 	}

// 	const fetchAverageScore = (category) => {
// 		API({
// 			method: "GET",
// 			url: `get/average/score?category=${category}`
// 		}).then(res => {
// 			setAverageScore(res.data.data);
// 		}).catch(err => console.log(err));
// 	}

// 	return (
// 		<div className={`progress-card ${class_name}`}>
// 			<div className="d-flex justify-content-between  flex-md-column flex-lg-row">
// 				<h4>
// 				<img src={icon} alt={title} /> {title}
// 			</h4>
// 			<p className="question-practiced">Question Practiced</p>
// 			</div>
// 			<div className="progress-container">
// 				<div className="progress-title">
// 					{/* {showAverageScore === 1 &&
// 						<> */}
// 							<Link
// 								className="progress-percentage link-style"
// 								to={`/admin/progress/${category}?mock=0`}
// 							>
// 								View details
// 								<img src={RightArrow} alt="LA" />
// 							</Link>
// 						{/* </>
// 					} */}

// 					<div className="progress-text d-flex flex-column align-items-end">
// 						<p className="completed">{completed}</p>
// 						<span className="color question-practiced">of {total}</span>
// 					</div>
// 					{/*<div className="progress-percentage">{percentage}%</div>*/}
// 				</div>
// 				{/*<div style={{ height: "8px" }}>
// 					<div
// 						className="progress-fill"
// 						style={{ width: "0%" }}
// 					></div>
// 				</div>*/}
// 				{/* <div className="progress-bar">
// 					<div
// 						className="progress-fill"
// 						style={{ width: `${(percentage)}%` }}
// 					></div>
// 				</div> */}
// 			</div>
// 		</div>
// 	);
// };

// export default StatCategories;

import React, { useState, memo, useEffect } from "react";
import API from "api.js";

import SpeakingZoneIcon from "assets/images/images_new/microphone-icon.svg";
import WritingZoneIcon from "assets/images/images_new/writing-icon.svg";
import ReadingZoneIcon from "assets/images/images_new/reading-icon.svg";
import ListeningZoneIcon from "assets/images/images_new/listening-icon.svg";
import RightArrow from "assets/images/images_new/right-arrow.svg";
import { Link } from "react-router-dom";
import ExamPopup from "components/PopUps/ExamPopup";

const StatCategories = memo(function StatCategories({
	practiceData, showAverageScore,mockData,examDate,setExamDate,examDatePopup,loadDashboardData
}) {
    const [examIsOpen, setExamIsOpen] = useState(false);
	//  Speaking = 1
	//  Writing = 2
	//  Reading = 3
	//  Listening = 4

  const toggleExam = () => setExamIsOpen((prevState) => !prevState);
	  const saveExamDate = (e, selected_date) => {
		API({
		  url: "updateExamDate",
		  method: "POST",
		  data: { exam_date: selected_date },
		})
		  .then((res) => {
			const { days_left } = res.data;
			loadDashboardData();
			toggleExam();
			setExamDate(selected_date);
		  })
		  .catch((err) => {
			console.log("err", err);
		  });
	  };
	  
 useEffect(() => {
	// console.log('exam_date :- ',examDatePopup)
	setExamIsOpen(examDatePopup);
  }, [examDate]);
  
	return (
		<>
		<div id="tour-stats" className="pl-md-0"  >
			<div className="progress-section">
				<Section
					data={practiceData}
					title="Speaking"
					icon={SpeakingZoneIcon}
					class_name="speaking"
					category={1}
					showAverageScore={showAverageScore}
				/>

				<Section
					data={practiceData}
					title="Writing"
					icon={WritingZoneIcon}
					class_name="writing"
					category={2}
					showAverageScore={showAverageScore}
				/>

				<Section
					data={practiceData}
					title="Reading"
					icon={ReadingZoneIcon}
					class_name="reading"
					category={3}
					showAverageScore={showAverageScore}
				/>

				<Section
					data={practiceData}
					title="Listening"
					icon={ListeningZoneIcon}
					class_name="listening"
					category={4}
					showAverageScore={showAverageScore}
				/>
				<div className="countdown-card">
                <h3 className="m-0 text-center">EXAM COUNTDOWN</h3>
		        <div className="d-flex align-items-center flex-column">
					<h2 className="m-0">{mockData?.days_left}</h2>
		        <p className="m-0">days remaining</p>
				</div>
				<h3 className="m-0 FS12 fw-500">{mockData?.exam_date}</h3>
		        <button className="readiness" onClick={()=>{setExamIsOpen(true);}}>Set Exam Date</button>
		        </div>
			</div>
		</div>
		{
		examIsOpen && (
		<ExamPopup
		isOpen={examIsOpen}
          toggle={toggleExam}
          submit={saveExamDate}
          examDate={examDate}
				/>
			)
		}
		</>
	);
});


const Section = ({
	data, title, icon, class_name, category, showAverageScore
}) => {

	const [percentage, setPercentage] = useState(0);
	const [completed, setCompleted] = useState(0);
	const [total, setTotal] = useState(0);
	const [averageScore, setAverageScore] = useState(null);

	useEffect(() => {
		if (data) {
			switch(category) {
				case 1:
					setData(data.speaking);
					break;
				case 2:
					setData(data.writing);
					break;
				case 3:
					setData(data.reading);
					break;
				case 4:
					setData(data.listening);
					break;
				default:
					break;
			}
		}
	}, [data]);

	const setData = (d) => {
		setCompleted(d.done);
		setTotal(d.total);
		setPercentage(parseFloat((d.done / d.total) * 100).toFixed(2));
	}

	const fetchAverageScore = (category) => {
		API({
			method: "GET",
			url: `get/average/score?category=${category}`
		}).then(res => {
			setAverageScore(res.data.data);
		}).catch(err => console.log(err));
	}

	return (
		<>
		<div className={`progress-card ${class_name}`}>
			<div className="d-flex justify-content-between flex-md-column flex-lg-row">
			<div className="d-flex flex-column gap-1">
				<img src={icon} alt={title} width={"20px"}/> 
			<h4>{title}</h4>
			</div>
			<Link
			className="progress-percentage link-style FS14FW600 fw-500"
			to={`/admin/progress/${category}?mock=0`}
			style={{zIndex:"unset"}}
			>
			View details
			<img src={RightArrow} alt="LA" />
			</Link>
			
			</div>
			<div className="progress-container mt-4">
					<div className="progress-text d-flex flex-column">
					<p className="completed">{completed} <span className="color question-practiced">/ {total}</span></p>
						
					</div>
				<div className="progress-title mt-0">
					<p className="question-practiced">Question Practiced</p>
				</div>
			</div>
		</div>
		</>
	);
};

export default StatCategories;